//电压值标签
export function myRectangle(ctx, node) {
  var wr = node.borderRadius;
  var hr = node.borderRadius;

  if (node.borderRadius < 1) {
    wr = node.rect.width * node.borderRadius;
    hr = node.rect.height * node.borderRadius;
  }

  var r = wr < hr ? wr : hr;

  if (node.rect.width < 2 * r) {
    r = node.rect.width / 2;
  }

  if (node.rect.height < 2 * r) {
    r = node.rect.height / 2;
  }

  ctx.beginPath();
  ctx.moveTo(node.rect.x + r, node.rect.y);
  if(node.preText){
    let orginFillStyle=ctx.fillStyle;
    if(node.preTextFontStyle&&node.preTextFontStyle.fontSize){
        ctx.font = (node.fontStyle || 'normal') + " normal " + (node.fontWeight || 'normal') + " " + node.preTextFontStyle.fontSize + "px/" + node.lineHeight + " " + node.fontFamily;
    }
    if (node.preTextFontStyle.fontColor) {
      ctx.fillStyle = node.preTextFontStyle.fontColor;
    } 
    var metrics = ctx.measureText(node.preText);
    ctx.fillText(node.preText,node.rect.x-Math.floor(metrics.width)-5,node.rect.y+node.rect.height/2);
    ctx.fillStyle=orginFillStyle;
  }
  if(node.endText){
    let orginFillStyle=ctx.fillStyle;
    if(node.endTextFontStyle&&node.endTextFontStyle.fontSize){
        ctx.font = (node.fontStyle || 'normal') + " normal " + (node.fontWeight || 'normal') + " " + node.endTextFontStyle.fontSize + "px/" + node.lineHeight + " " + node.fontFamily;
    }
    if (node.endTextFontStyle.fontColor) {
      ctx.fillStyle = node.endTextFontStyle.fontColor;
    } 
    ctx.fillText(node.endText,node.rect.x+node.rect.width+5,node.rect.y+node.rect.height/2);
    ctx.fillStyle=orginFillStyle;
  }
  
  
  ctx.arcTo(node.rect.x + node.rect.width, node.rect.y, node.rect.x + node.rect.width, node.rect.y + node.rect.height, r);
  ctx.arcTo(node.rect.x + node.rect.width, node.rect.y + node.rect.height, node.rect.x, node.rect.y + node.rect.height, r);
  ctx.arcTo(node.rect.x, node.rect.y + node.rect.height, node.rect.x, node.rect.y, r);
  ctx.arcTo(node.rect.x, node.rect.y, node.rect.x + node.rect.width, node.rect.y, r);
  ctx.closePath();
  (node.fillStyle || node.bkType) && ctx.fill();
  ctx.stroke();
}